import type { PropsWithChildren } from "react";
import { useSession } from "../auth/sessionContext";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { hasCatalogReplyActivityAccess } from "./commerceAccess";
import styles from "./CommerceRouteGuard.module.css";

export function CatalogReplyActivityRouteGuard({ children }: PropsWithChildren) {
  const session = useSession();
  if (!hasCatalogReplyActivityAccess(session)) {
    return (
      <section className={styles.denied} data-status-code="403" aria-label="Catalog reply activity unavailable">
        <InlineNotice tone="error" title="Catalog reply activity unavailable">
          This operational queue is available only to entitled workspace owners, managers and staff.
        </InlineNotice>
      </section>
    );
  }
  return children;
}
